import { render, staticRenderFns } from "./TwilioHeader.vue?vue&type=template&id=8c60b580&scoped=true"
import script from "./TwilioHeader.vue?vue&type=script&lang=js"
export * from "./TwilioHeader.vue?vue&type=script&lang=js"
import style0 from "./TwilioHeader.vue?vue&type=style&index=0&id=8c60b580&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c60b580",
  null
  
)

export default component.exports